import { Dispatch } from 'redux';
import { api } from '../../configuration/api/apiHelper';
import {
  CreateReviewCommand,
  ReviewViewModel,
  SubmitReviewCommand,
  ReviewType,
} from '../../configuration/api/apiSchema';

// Action Types
export const GET_REVIEWS_REQUEST = 'GET_REVIEWS_REQUEST';
export const GET_REVIEWS_SUCCESS = 'GET_REVIEWS_SUCCESS';
export const GET_REVIEWS_FAILURE = 'GET_REVIEWS_FAILURE';

export const GET_USER_REVIEWS_REQUEST = 'GET_USER_REVIEWS_REQUEST';
export const GET_USER_REVIEWS_SUCCESS = 'GET_USER_REVIEWS_SUCCESS';
export const GET_USER_REVIEWS_FAILURE = 'GET_USER_REVIEWS_FAILURE';

export const GET_ORDER_REVIEWS_REQUEST = 'GET_ORDER_REVIEWS_REQUEST';
export const GET_ORDER_REVIEWS_SUCCESS = 'GET_ORDER_REVIEWS_SUCCESS';
export const GET_ORDER_REVIEWS_FAILURE = 'GET_ORDER_REVIEWS_FAILURE';

export const CREATE_REVIEW_REQUEST = 'CREATE_REVIEW_REQUEST';
export const CREATE_REVIEW_SUCCESS = 'CREATE_REVIEW_SUCCESS';
export const CREATE_REVIEW_FAILURE = 'CREATE_REVIEW_FAILURE';

export const SUBMIT_REVIEW_REQUEST = 'SUBMIT_REVIEW_REQUEST';
export const SUBMIT_REVIEW_SUCCESS = 'SUBMIT_REVIEW_SUCCESS';
export const SUBMIT_REVIEW_FAILURE = 'SUBMIT_REVIEW_FAILURE';

// Action Creators
export const getReviews =
  (
    userId?: string,
    orderId?: string,
    type?: ReviewType,
    page: number = 1,
    pageSize: number = 10,
  ) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: GET_REVIEWS_REQUEST });
    try {
      const response = await api.reviews.reviewsList({
        userId,
        orderId,
        type,
        page,
        pageSize,
        languageKey: 'en',
      });
      dispatch({ type: GET_REVIEWS_SUCCESS, payload: response.data });
    } catch (error: any) {
      dispatch({
        type: GET_REVIEWS_FAILURE,
        payload: error.message || 'Failed to fetch reviews',
      });
    }
  };

export const getUserReviews =
  (userId: string, page: number = 1, pageSize: number = 10) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: GET_USER_REVIEWS_REQUEST, payload: { userId } });
    try {
      const response = await api.reviews.userDetail(userId, {
        page,
        pageSize,
        languageKey: 'en',
      });
      dispatch({
        type: GET_USER_REVIEWS_SUCCESS,
        payload: {
          userId,
          reviews: response.data.reviews,
          totalCount: response.data.totalCount,
        },
      });
    } catch (error: any) {
      dispatch({
        type: GET_USER_REVIEWS_FAILURE,
        payload: error.message || 'Failed to fetch user reviews',
      });
    }
  };

export const getOrderReviews =
  (orderId: string, page: number = 1, pageSize: number = 10) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: GET_ORDER_REVIEWS_REQUEST });
    try {
      const response = await api.reviews.orderDetail(orderId, {
        page,
        pageSize,
        languageKey: 'en',
      });
      dispatch({ type: GET_ORDER_REVIEWS_SUCCESS, payload: response.data });
    } catch (error: any) {
      dispatch({
        type: GET_ORDER_REVIEWS_FAILURE,
        payload: error.message || 'Failed to fetch order reviews',
      });
    }
  };

export const createReview =
  (reviewData: CreateReviewCommand) => async (dispatch: Dispatch) => {
    dispatch({ type: CREATE_REVIEW_REQUEST });
    try {
      const response = await api.reviews.reviewsCreate(reviewData);
      dispatch({ type: CREATE_REVIEW_SUCCESS, payload: response.data });
      return response.data;
    } catch (error: any) {
      dispatch({
        type: CREATE_REVIEW_FAILURE,
        payload: error.message || 'Failed to create review',
      });
      throw error;
    }
  };

export const submitReview =
  (reviewId: string, data: SubmitReviewCommand) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: SUBMIT_REVIEW_REQUEST });
    try {
      const response = await api.reviews.submitCreate(reviewId, data);
      dispatch({ type: SUBMIT_REVIEW_SUCCESS, payload: response.data });
      return response.data;
    } catch (error: any) {
      dispatch({
        type: SUBMIT_REVIEW_FAILURE,
        payload: error.message || 'Failed to submit review',
      });
      throw error;
    }
  };
